<template>
  <div class="stars">
    <i 
      v-for="(star, index) in 5" 
      :key="index"
      :class="getStarClass(index + 1)"
    ></i>
  </div>
</template>

<script>
export default {
  props: {
    mediaAvaliacoes: {
      type: Number,
      required: true
    }
  },
  methods: {
    getStarClass(position) {
      if (this.mediaAvaliacoes >= position) {
        return "bi bi-star-fill"; // estrela cheia
      } else if (this.mediaAvaliacoes >= position - 0.5) {
        return "bi bi-star-half"; // meia estrela
      } else {
        return "bi bi-star"; // estrela vazia
      }
    }
  }
};
</script>
